<template>
    <transition>
        <div @click="toTop" v-if="topShow" class="me-to-top">
            <i class="el-icon-caret-top"></i>
        </div>
    </transition>
</template>

<script>
    export default {
        name: 'GoTop',
        data() {
            return {
                topShow: false//默认不在底部就不显示
            }
        },
        methods:
            {
                toTop()//回到顶部
                {
                    document.body.scrollTop = 0;
                    document.documentElement.scrollTop = 0;
                    this.topShow = false;
                },
                needToTop() {
                    let currentHeight = document.documentElement.scrollTop || document.body.scrollTop;
                    this.topShow = currentHeight > 400;
                },
            },
        mounted() {
            this.$nextTick(() => {
                //对窗体的滚动添加一个事件，监听窗体的滚动（只要滚动栏一滚动，该事件就生效）
                window.addEventListener("scroll", this.needToTop);
            });
        }
    }
</script>

<style>
    .me-to-top {
        background-color: #fff;
        position: fixed;
        right: 100px;
        bottom: 150px;
        width: 40px;
        height: 40px;
        border-radius: 20px;
        cursor: pointer;
        transition: .3s;
        box-shadow: 0 0 6px rgba(0, 0, 0, .12);
        z-index: 5;
    }

    .me-to-top i {
        color: #00d1b2;
        display: block;
        line-height: 40px;
        text-align: center;
        font-size: 18px;
    }
</style>
